let allOriginInvestors = [];
let activeOriginInvestors = [];

jQuery(document).ready(function () {


    if (typeof Papa !== 'undefined') {

        jQuery.get('https://docs.google.com/spreadsheets/d/e/2PACX-1vSiL_Fa6d5ArP5lKd5LP2pIHuqf2f1B9pxi1_EZMDnQbRm5BSVkJLvf7YLxy3OxdT1rI0s7SFc1xqae/pub?gid=0&single=true&output=csv', function (result) {
            if (result) {
                var subscribers = Papa.parse(result).data[0][0];
                if (subscribers) {
                    jQuery('.registered-users-number').html(subscribers);
                    jQuery('.registered-users-block').show();
                }
            }

        });
    }

    jQuery('.map-tab').click((event) => {
        if (event.target.value === 'all_investors') {
            jQuery('#map-loader').show();
            jQuery('.map-tab').removeClass('active');
            event.target.classList.add('active');
            initOriginInvestors(allOriginInvestors);
        }

        if (event.target.value === 'active_investors') {
            jQuery('#map-loader').show();
            jQuery('.map-tab').removeClass('active');
            event.target.classList.add('active');
            initOriginInvestors(activeOriginInvestors);
        }
    });

    var addPercentToLabel = function (value = 0, total = 0, characterToAdd = '%') {
        return sliceWithoutRounding(Number(value) / Number(total) * 100, 3) + ' %';
    }

    var renderChartForLoansByRate = function (data = []) {
        // Statistics for loans by rate
        var loansByRate = document.getElementById('loansByRate').getContext('2d');
        var loansByRateLabels = data.reduce(function (reducer, curr) {
            reducer = [
                ...reducer,
                curr.risk,
            ];

            return reducer;
        }, []);

        var loansByRateData = data.reduce(function (reducer, curr) {
            reducer = [
                ...reducer,
                curr.total,
            ]

            return reducer;
        }, []);
        var loansByRateColors = [];

        loansByRateLabels.forEach(function (label) {
            switch (label) {
                case 'A':
                    loansByRateColors.push('#0e3150');
                    break;
                case 'B':
                    loansByRateColors.push('#6dc9c8');
                    break;
                case 'C':
                    loansByRateColors.push('#53d397');
                    break;
                case 'D':
                    loansByRateColors.push('#7da87b');
                    break;
                case 'E':
                    loansByRateColors.push('#f8c43a');
                    break;
                case 'F':
                    loansByRateColors.push('#df8931');
                    break;
                case 'G':
                    loansByRateColors.push('#dd7777');
                    break;
            }
        });

        var total = loansByRateData.reduce((r, c) => Number(r) + Number(c), 0);

        loansByRateLabels.forEach((item, index) => {
            jQuery('#byRateLegend').append(`
            <span>
              <span style="background-color: ${loansByRateColors[index]}; width: 30px; height: 10px; display: inline-block;"></span>
              <span style="color: rgba(114, 114, 114, 1); font-size: 12px;">${item}</span>
            </div>
       `)
        });

        if (window && window.innerWidth && window.innerWidth > 600) {
            var chartByRate = new Chart(loansByRate, {
                // The type of chart we want to create
                type: 'doughnut',

                // The data for our dataset
                data: {
                    labels: loansByRateLabels,
                    datasets: [
                        {
                            label: 'My First dataset',
                            backgroundColor: loansByRateColors,
                            data: loansByRateData
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    legend: {
                        responsive: true,
                        position: 'bottom',
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: (tooltipItems) => addPercentToLabel(loansByRateData[tooltipItems.index], total, '%'),
                        }
                    },
                    onResize: function (myChart, size) {
                        if (window.innerWidth <= 600) {
                            myChart.legend.options.display = false;
                        } else {
                            myChart.legend.options.display = true;
                        }
                    }
                }
            });
        }

        if (window && window.innerWidth && window.innerWidth <= 600) {
            var chartByRateMobile = new Chart(loansByRate, {
                // The type of chart we want to create
                type: 'doughnut',

                // The data for our dataset
                data: {
                    datasets: [
                        {
                            label: 'My First dataset',
                            backgroundColor: loansByRateColors,
                            data: loansByRateData
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    legend: {
                        responsive: true,
                        position: 'bottom',
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: (tooltipItems) => addPercentToLabel(loansByRateData[tooltipItems.index], total, '%'),
                        }
                    },
                    onResize: function (myChart, size) {
                        if (window.innerWidth <= 600) {
                            myChart.legend.options.display = false;
                        } else {
                            myChart.legend.options.display = true;
                        }
                    }
                }
            });
        }
    }

    var renderCharByPeriod = function (data = []) {
        // Statistics for loans by period
        var loansByPeriod = document.getElementById('loansByPeriod').getContext('2d');
        var engLang = window.location.href.indexOf('/en/') !== -1;
        var loansByPeriodLabels = data.reduce(function (reducer, curr) {
            reducer = [
                ...reducer,
                curr.period + (engLang ? ' Months' : ' Luni'),
            ]
            return reducer;
        }, []);
        var loansByPeriodData = data.reduce(function (reducer, curr) {
            reducer = [
                ...reducer,
                curr.total,
            ];
            return reducer;
        }, []);
        var loansByPeriodColors = [];

        loansByPeriodLabels.forEach(function (label) {
            loansByPeriodColors.push(dynamicColors());
        });

        var total = loansByPeriodData.reduce((r, c) => Number(r) + Number(c), 0);

        loansByPeriodLabels.forEach((item, index) => {
            jQuery('#byPeriodLegend').append(`
        <span>
          <span style="background-color: ${loansByPeriodColors[index]}; width: 30px; height: 10px; display: inline-block;"></span>
          <span style="color: rgba(114, 114, 114, 1); font-size: 12px;">${item}</span>
        </div>
      `)
        });

        if (window && window.innerWidth && window.innerWidth > 600) {
            var chartByPeriod = new Chart(loansByPeriod, {
                // The type of chart we want to create
                type: 'doughnut',

                // The data for our dataset
                data: {
                    labels: loansByPeriodLabels,
                    datasets: [
                        {
                            label: 'My First dataset',
                            backgroundColor: loansByPeriodColors,
                            data: loansByPeriodData
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    legend: {
                        responsive: true,
                        position: 'bottom',
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: (tooltipItems) => addPercentToLabel(loansByPeriodData[tooltipItems.index], total, '%'),
                        }
                    },
                    onResize: function (myChart, size) {
                        if (window.innerWidth <= 600) {
                            myChart.legend.options.display = false;
                        } else {
                            myChart.legend.options.display = true;
                        }
                    }
                }
            });
        }

        if (window && window.innerWidth && window.innerWidth <= 600) {
            var chartByPeriodMobile = new Chart(loansByPeriod, {
                // The type of chart we want to create
                type: 'doughnut',

                // The data for our dataset
                data: {
                    datasets: [
                        {
                            label: 'My First dataset',
                            backgroundColor: loansByPeriodColors,
                            data: loansByPeriodData
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    legend: {
                        responsive: true,
                        position: 'bottom',
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: (tooltipItems) => addPercentToLabel(loansByPeriodData[tooltipItems.index], total, '%'),
                        }
                    },
                    onResize: function (myChart, size) {
                        if (window.innerWidth <= 600) {
                            myChart.legend.options.display = false;
                        } else {
                            myChart.legend.options.display = true;
                        }
                    }
                }
            });
        }
    }

    var renderChartByScope = function (data = []) {
        // Statistics for loans by scope
        var loansByScope = document.getElementById('loans-by-scope').getContext('2d');
        var loansByScopeLabels = [
            'Pentru procurarea automobilului', 'Pentru nuntă', 'Pentru afacere',
            'Pentru achitarea cardului de credit', 'Pentru achiziții majore',
            'Pentru tratament medical', 'Pentru odihnă', 'Pentru amenajarea casei',
            'Pentru refinanțarea altor credite', 'Pentru alte scopuri'
        ];
        var loansByScopeLabelsEn = [
            'For the purchase of the car', 'For the wedding', 'For business',
            'For credit card payment', 'For major purchases', 'For medical treatment',
            'For rest', 'For arranging the house', 'For refinancing other loans',
            'For other purposes'
        ]
        var carScope = data.find((item) => item.scope === 'CAR');
        var weddingScope = data.find((item) => item.scope === 'WEDDING');
        var businessScope = data.find((item) => item.scope === 'BUSINESS');
        var creditCardScope = data.find((item) => item.scope === 'CREDIT_CARD');
        var bigProcurmentScope = data.find((item) => item.scope === 'BIG_PROCUREMENT');
        var medicalScope = data.find((item) => item.scope === 'MEDICAL');
        var holidayScope = data.find((item) => item.scope === 'HOLIDAY');
        var houseHoldScope = data.find((item) => item.scope === 'HOUSEHOLD');
        var refinancigScope = data.find((item) => item.scope === 'LOAN_REFINANCING');
        var otherScope = data.find((item) => item.scope === 'OTHER');

        var loansByScopeData = [
            carScope ? carScope.total : 0, weddingScope ? weddingScope.total : 0,
            businessScope ? businessScope.total : 0, creditCardScope ? creditCardScope.total : 0,
            bigProcurmentScope ? bigProcurmentScope.total : 0, medicalScope ? medicalScope.total : 0,
            holidayScope ? holidayScope.total : 0, houseHoldScope ? houseHoldScope.total : 0,
            refinancigScope ? refinancigScope.total : 0, otherScope ? otherScope.total : 0
        ]
        var loansByScopeColors = [];

        loansByScopeLabels.forEach(function (label) {
            loansByScopeColors.push(dynamicColors());
        });


        var total = loansByScopeData.reduce((r, c) => Number(r) + Number(c), 0);

        var engLang = window.location.href.indexOf('/en/') !== -1;

        if (engLang) {
            loansByScopeLabelsEn.forEach((item, index) => {
                jQuery('#byScopeLegend').append(`
        <span>
          <span style="background-color: ${loansByScopeColors[index]}; width: 30px; height: 10px; display: inline-block;"></span>
          <span style="color: rgba(114, 114, 114, 1); font-size: 12px;">${item}</span>
        </div>
      `)
            });
        } else {
            loansByScopeLabels.forEach((item, index) => {
                // console.log({ item })
                jQuery('#byScopeLegend').append(`
                <span>
                  <span style="background-color: ${loansByScopeColors[index]}; width: 30px; height: 10px; display: inline-block;"></span>
                  <span style="color: rgba(114, 114, 114, 1); font-size: 12px;">${item}</span>
                </div>
            `)
            });
        }


        if (window && window.innerWidth && window.innerWidth > 600) {
            var chartByScope = new Chart(loansByScope, {
                // The type of chart we want to create
                type: 'doughnut',

                // The data for our dataset
                data: {
                    labels: engLang ? loansByScopeLabelsEn : loansByScopeLabels,
                    datasets: [
                        {
                            label: 'My First dataset',
                            backgroundColor: loansByScopeColors,
                            data: loansByScopeData
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    legend: {
                        responsive: false,
                        position: 'bottom',
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: (tooltipItems) => addPercentToLabel(loansByScopeData[tooltipItems.index], total, '%'),
                        }
                    },
                    onResize: function (myChart, size) {
                        if (window.innerWidth <= 600) {
                            myChart.legend.options.display = false;
                        } else {
                            myChart.legend.options.display = true;
                        }
                    }
                }
            });
        }

        if (window && window.innerWidth && window.innerWidth <= 600) {
            var chartByScopeMobile = new Chart(loansByScope, {
                // The type of chart we want to create
                type: 'doughnut',

                // The data for our dataset
                data: {
                    datasets: [
                        {
                            label: 'My First dataset',
                            backgroundColor: loansByScopeColors,
                            data: loansByScopeData
                        }
                    ]
                },

                // Configuration options go here
                options: {
                    legend: {
                        responsive: false,
                        position: 'bottom',
                    },
                    tooltips: {
                        enabled: true,
                        mode: 'single',
                        callbacks: {
                            label: (tooltipItems) => addPercentToLabel(loansByScopeData[tooltipItems.index], total, '%'),
                        }
                    },
                    onResize: function (myChart, size) {
                        if (window.innerWidth <= 600) {
                            myChart.legend.options.display = false;
                        } else {
                            myChart.legend.options.display = true;
                        }
                    }
                }
            });
        }
    }

    var renderCharLoansTotalAmount = function (data = {}) {
        // Statistics for loans amount per month
        var loansAmoutPerMonth = document.getElementById('loans-amount-per-month').getContext('2d');
        var labels = [];
        var dataAmounts = [];

        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                for (var sKey in data[key]) {
                    labels = [
                        ...labels,
                        `${data[key][sKey].from.slice(0, data[key][sKey].from.lastIndexOf('-'))}`
                    ];

                    dataAmounts = [
                        ...dataAmounts,
                        Number(data[key][sKey].total),
                    ]
                }
            }
        }

        for (var i = 0; i < dataAmounts.length; i++) {
            if (i < 1) {
                dataAmounts[i] = dataAmounts[i];
            } else {
                dataAmounts[i] = dataAmounts[i] + dataAmounts[i - 1];
            }
        }

        var chart = new Chart(loansAmoutPerMonth, {
            type: 'bar',
            data: {
                labels,
                datasets: [
                    {
                        label: false,
                        backgroundColor: "#3e95cd",
                        data: dataAmounts,
                    },
                ]
            },
            options: {
                legend: false,
            }
        });
    }

    if (typeof Papa !== 'undefined') {
        jQuery.get('https://api.app.fagura.com/api/public/statistics', function (result) {
            if (result) {
                var engLang = false;

                if (result.hasOwnProperty('activeLoans')) {
                    var activeLoans = document.getElementById('active-loans');
                    activeLoans.innerText = result.activeLoans;
                }

                if (result.hasOwnProperty('investorInterestFee')) {
                    var investorInterestFee = document.getElementById('investor-interest-fee');
                    investorInterestFee.innerHTML = sliceWithoutRounding(result.investorInterestFee, 3) + ' EUR';
                }

                if (result.hasOwnProperty('loansAverageRate')) {
                    var interestAverage = document.getElementById('interest-average');
                    interestAverage.innerHTML = sliceWithoutRounding(result.loansAverageRate, 3) + ' %';
                }

                if (result.hasOwnProperty('loansAveragePeriod')) {
                    var averagePeriod = document.getElementById('average-period');
                    averagePeriod.innerHTML = sliceWithoutRounding(result.loansAveragePeriod, 0) + (engLang ? ' Months' : ' Luni');
                }

                if (result.hasOwnProperty('loansAverageSum')) {
                    var averagePeriod = document.getElementById('average-loan-sum');
                    averagePeriod.innerHTML = sliceWithoutRounding(result.loansAverageSum, 0) + ' EUR';
                }

                if (result.hasOwnProperty('loansByScoringRate')) {
                    renderChartForLoansByRate(result.loansByScoringRate);
                }

                if (result.hasOwnProperty('loansByPeriods')) {
                    renderCharByPeriod(result.loansByPeriods);
                }

                if (result.hasOwnProperty('loansByScope')) {
                    renderChartByScope(result.loansByScope);
                }

                if (result.hasOwnProperty('activeLoansAmount')) {
                    renderCharLoansTotalAmount(result.activeLoansAmount);
                }

                if (result.hasOwnProperty('originInvestors')) {
                    allOriginInvestors = result.originInvestors;
                }

                if (result.hasOwnProperty('originActiveInvestors')) {
                    const activeInvestors = result.originActiveInvestors.filter((item) => item.country_code != '+1');
                    initOriginInvestors(activeInvestors);
                    activeOriginInvestors = activeInvestors;
                }

                // Hide loader and show statistics.
                jQuery('#loading').hide();
                jQuery('#statistics').show();
            }
        });
    }


    // Google Analytics
    jQuery('.nav a').on('click', function () {
        ga('send', 'event', 'button', jQuery(this).attr('data-event'));
    });

});


const sliceWithoutRounding = function (number, length) {
    return number.toString().slice(0, number.toString().indexOf('.') + length);
}

// Get dynamic colors for doughnut chart
const dynamicColors = function () {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
};

function initOriginInvestors(originInvestors) {
    am4core.ready(function () {

        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create map instance
        var chart = am4core.create("origin-investors-map", am4maps.MapChart);

        // Set map definition
        chart.geodata = am4geodata_worldHigh;

        // Set projection
        chart.projection = new am4maps.projections.Mercator();

        // Export
        chart.exporting.menu = new am4core.ExportMenu();

        // Zoom control
        chart.zoomControl = new am4maps.ZoomControl();

        var homeButton = new am4core.Button();
        homeButton.events.on("hit", function () {
            chart.goHome();
        });

        homeButton.icon = new am4core.Sprite();
        homeButton.padding(7, 5, 7, 5);
        homeButton.width = 30;
        homeButton.icon.path = "M16,8 L14,8 L14,16 L10,16 L10,10 L6,10 L6,16 L2,16 L2,8 L0,8 L8,0 L16,8 Z M16,8";
        homeButton.marginBottom = 10;
        homeButton.parent = chart.zoomControl;
        homeButton.insertBefore(chart.zoomControl.plusButton);

        // Center on the groups by default
        chart.homeZoomLevel = 1;
        chart.homeGeoPoint = { longitude: 10, latitude: 52 };

        var testData = [];
        var countriesGroup = [];

        if (originInvestors) {
            const max = Math.max(...originInvestors.map((investor) => Number(investor.count)));

            originInvestors.forEach(function (investor) {
                if (investor && investor.country_code && investor.count) {
                    const countries = getCountry(investor.country_code);
                    const randomOpacity = (investor.count / max) * 100;
                    // console.log(countries);
                    let groupExist = false;

                    const uniqueId = Math.floor(Math.random() * max);
                    countries.forEach((country) => {
                        country.uniqueId = uniqueId;
                    });

                    testData.forEach((group) => {
                        if (group && group.data && group.data.length) {
                            group.data.forEach((data) => {
                                // console.log(countries.map((country) => country.code).includes(data.id));
                                if (countries.map((country) => country.code).includes(data.id)) groupExist = true;
                            })
                        }
                    })

                    const transparency = randomOpacity === 100 ? 1 : randomOpacity < 1 ? '0.' + Math.ceil(randomOpacity + 2).toString() : '0.' + parseInt(randomOpacity + 3)
                    if (!groupExist) {
                        testData.push({
                            "name": 'Group',
                            "color": `rgba(247, 148, 30, ${transparency})`,
                            "data": countries && countries.length > 1 ? countries.map((country) => {
                                return {
                                    "title": countries.map((country) => country.name).filter((item, i, ar) => ar.indexOf(item) === i).join(', '),
                                    "id": country.code,
                                    "customData": investor.count,
                                    "groupId": `${country.uniqueId}`
                                }
                            }) : countries.map((country) => {
                                return {
                                    "title": country.name,
                                    "id": country.code,
                                    "customData": investor.count,
                                }
                            })
                        });
                    }
                }
            })
        }
        // This array will be populated with country IDs to exclude from the world series
        var excludedCountries = ["AQ"];

        // Create a series for each group, and populate the above array
        testData.forEach(function (group) {
            var series = chart.series.push(new am4maps.MapPolygonSeries());
            series.name = group.name;
            series.useGeodata = true;
            var includedCountries = [];
            group.data.forEach(function (country) {
                includedCountries.push(country.id);
                excludedCountries.push(country.id);
            });
            series.include = includedCountries;

            series.fill = am4core.color(group.color);

            // By creating a hover state and setting setStateOnChildren to true, when we
            // hover over the series itself, it will trigger the hover SpriteState of all
            // its countries (provided those countries have a hover SpriteState, too!).
            series.setStateOnChildren = true;
            series.calculateVisualCenter = true;

            // Country shape properties & behaviors
            var mapPolygonTemplate = series.mapPolygons.template;
            // Instead of our custom title, we could also use {name} which comes from geodata
            mapPolygonTemplate.fill = am4core.color(group.color);
            mapPolygonTemplate.fillOpacity = 0.8;
            mapPolygonTemplate.nonScalingStroke = true;
            mapPolygonTemplate.tooltipPosition = "fixed"

            mapPolygonTemplate.events.on("over", function (event) {
                series.mapPolygons.each(function (mapPolygon) {
                    mapPolygon.isHover = true;
                })
                event.target.isHover = false;
                event.target.isHover = true;
            })

            mapPolygonTemplate.events.on("out", function (event) {
                series.mapPolygons.each(function (mapPolygon) {
                    mapPolygon.isHover = false;
                })
            })

            // States
            var hoverState = mapPolygonTemplate.states.create("hover");
            hoverState.properties.fill = am4core.color("rgb(184, 91, 0)");

            // Tooltip
            mapPolygonTemplate.tooltipText = "{title}, {customData} Investors"; // enables tooltip
            // series.tooltip.getFillFromObject = false; // prevents default colorization, which would make all tooltips red on hover
            // series.tooltip.background.fill = am4core.color(group.color);

            // MapPolygonSeries will mutate the data assigned to it,
            // we make and provide a copy of the original data array to leave it untouched.
            // (This method of copying works only for simple objects, e.g. it will not work
            //  as predictably for deep copying custom Classes.)
            series.data = JSON.parse(JSON.stringify(group.data));
        });

        // The rest of the world.
        var worldSeries = chart.series.push(new am4maps.MapPolygonSeries());
        var worldSeriesName = "world";
        worldSeries.name = worldSeriesName;
        worldSeries.useGeodata = true;
        worldSeries.exclude = excludedCountries;
        worldSeries.fillOpacity = 0.8;
        worldSeries.hiddenInLegend = true;
        worldSeries.mapPolygons.template.nonScalingStroke = true;
        jQuery('#map-loader').hide();
    });
}


function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

function getCountry(countryCode) {
    const countries = [
        { code: 'US', name: 'United States', countryCode: '+1' },
        { code: 'GB', name: 'United Kingdom', countryCode: '+44' },
        { code: 'CA', name: 'Canada', countryCode: '+1' },
        { code: 'AF', name: 'Afghanistan', countryCode: '+93' },
        { code: 'AX', name: 'Aland Islands', countryCode: '+358' },
        { code: 'AL', name: 'Albania', countryCode: '+355' },
        { code: 'DZ', name: 'Algeria', countryCode: '+213' },
        { code: 'AS', name: 'American Samoa', countryCode: '+1' },
        { code: 'AD', name: 'Andorra', countryCode: '+376' },
        { code: 'AO', name: 'Angola', countryCode: '+244' },
        { code: 'AI', name: 'Anguilla', countryCode: '+1264' },
        { code: 'AQ', name: 'Antarctica', countryCode: '+672' },
        { code: 'AG', name: 'Antigua And Barbuda', countryCode: '+1268' },
        { code: 'AR', name: 'Argentina', countryCode: '+54' },
        { code: 'AM', name: 'Armenia', countryCode: '+374' },
        { code: 'AN', name: 'Netherlands Antilles', countryCode: '+599' },
        { code: 'AW', name: 'Aruba', countryCode: '+297' },
        { code: 'AU', name: 'Australia', countryCode: '+61' },
        { code: 'AT', name: 'Austria', countryCode: '+43' },
        { code: 'AZ', name: 'Azerbaijan', countryCode: '+994' },
        { code: 'BS', name: 'Bahamas', countryCode: '+1242' },
        { code: 'BH', name: 'Bahrain', countryCode: '+973' },
        { code: 'BD', name: 'Bangladesh', countryCode: '+880' },
        { code: 'BB', name: 'Barbados', countryCode: '+1246' },
        { code: 'BY', name: 'Belarus', countryCode: '+375' },
        { code: 'BE', name: 'Belgium', countryCode: '+32' },
        { code: 'BZ', name: 'Belize', countryCode: '+501' },
        { code: 'BJ', name: 'Benin', countryCode: '+229' },
        { code: 'BM', name: 'Bermuda', countryCode: '+1441' },
        { code: 'BT', name: 'Bhutan', countryCode: '+975' },
        { code: 'BO', name: 'Bolivia', countryCode: '+591' },
        { code: 'BA', name: 'Bosnia And Herzegovina', countryCode: '+387' },
        { code: 'BW', name: 'Botswana', countryCode: '+267' },
        { code: 'BV', name: 'Bouvet Island', countryCode: '+47' },
        { code: 'BR', name: 'Brazil', countryCode: '+55' },
        { code: 'IO', name: 'British Indian Ocean Territory', countryCode: '+246' },
        { code: 'BN', name: 'Brunei Darussalam', countryCode: '+673' },
        { code: 'BG', name: 'Bulgaria', countryCode: '+359' },
        { code: 'BF', name: 'Burkina Faso', countryCode: '+226' },
        { code: 'BI', name: 'Burundi', countryCode: '+257' },
        { code: 'KH', name: 'Cambodia', countryCode: '+855' },
        { code: 'CM', name: 'Cameroon', countryCode: '+237' },
        { code: 'CV', name: 'Cape Verde', countryCode: '+238' },
        { code: 'KY', name: 'Cayman Islands', countryCode: '+1345' },
        { code: 'CF', name: 'Central African Republic', countryCode: '+236' },
        { code: 'TD', name: 'Chad', countryCode: '+235' },
        { code: 'CL', name: 'Chile', countryCode: '+56' },
        { code: 'CN', name: 'China', countryCode: '+86' },
        { code: 'CX', name: 'Christmas Island', countryCode: '+61' },
        { code: 'CC', name: 'Cocos (Keeling) Islands', countryCode: '+61' },
        { code: 'CO', name: 'Colombia', countryCode: '+57' },
        { code: 'KM', name: 'Comoros', countryCode: '+269' },
        { code: 'CG', name: 'Congo', countryCode: '+242' },
        { code: 'CD', name: 'Congo, Democratic Republic', countryCode: '+243' },
        { code: 'CK', name: 'Cook Islands', countryCode: '+682' },
        { code: 'CR', name: 'Costa Rica', countryCode: '+506' },
        { code: 'CI', name: 'Cote D\'Ivoire', countryCode: '+225' },
        { code: 'HR', name: 'Croatia', countryCode: '+385' },
        { code: 'CU', name: 'Cuba', countryCode: '+53' },
        { code: 'CY', name: 'Cyprus', countryCode: '+357' },
        { code: 'CZ', name: 'Czech Republic', countryCode: '+420' },
        { code: 'DK', name: 'Denmark', countryCode: '+45' },
        { code: 'DJ', name: 'Djibouti', countryCode: '+253' },
        { code: 'DM', name: 'Dominica', countryCode: '+1809' },
        { code: 'DO', name: 'Dominican Republic', countryCode: '+1809' },
        { code: 'EC', name: 'Ecuador', countryCode: '+593' },
        { code: 'EG', name: 'Egypt', countryCode: '+20' },
        { code: 'SV', name: 'El Salvador', countryCode: '+503' },
        { code: 'GQ', name: 'Equatorial Guinea', countryCode: '+240' },
        { code: 'ER', name: 'Eritrea', countryCode: '+291' },
        { code: 'EE', name: 'Estonia', countryCode: '+372' },
        { code: 'ET', name: 'Ethiopia', countryCode: '+251' },
        { code: 'FK', name: 'Falkland Islands (Malvinas)', countryCode: '+500' },
        { code: 'FO', name: 'Faroe Islands', countryCode: '+298' },
        { code: 'FJ', name: 'Fiji', countryCode: '+679' },
        { code: 'FI', name: 'Finland', countryCode: '+358' },
        { code: 'FR', name: 'France', countryCode: '+33' },
        { code: 'GF', name: 'French Guiana', countryCode: '+594' },
        { code: 'PF', name: 'French Polynesia', countryCode: '+689' },
        { code: 'TF', name: 'French Southern Territories', countryCode: '+262' },
        { code: 'GA', name: 'Gabon', countryCode: '+241' },
        { code: 'GM', name: 'Gambia', countryCode: '+220' },
        { code: 'GE', name: 'Georgia', countryCode: '+7880' },
        { code: 'DE', name: 'Germany', countryCode: '+49' },
        { code: 'GH', name: 'Ghana', countryCode: '+233' },
        { code: 'GI', name: 'Gibraltar', countryCode: '+350' },
        { code: 'GR', name: 'Greece', countryCode: '+30' },
        { code: 'GL', name: 'Greenland', countryCode: '+299' },
        { code: 'GD', name: 'Grenada', countryCode: '+1473' },
        { code: 'GP', name: 'Guadeloupe', countryCode: '+590' },
        { code: 'GU', name: 'Guam', countryCode: '+671' },
        { code: 'GT', name: 'Guatemala', countryCode: '+502' },
        { code: 'GG', name: 'Guernsey', countryCode: '+44' },
        { code: 'GN', name: 'Guinea', countryCode: '+224' },
        { code: 'GW', name: 'Guinea-Bissau', countryCode: '+245' },
        { code: 'GY', name: 'Guyana', countryCode: '+592' },
        { code: 'HT', name: 'Haiti', countryCode: '+509' },
        { code: 'HM', name: 'Heard Island & Mcdonald Islands', countryCode: '+672' },
        { code: 'VA', name: 'Holy See (Vatican City State)', countryCode: '+379' },
        { code: 'HN', name: 'Honduras', countryCode: '+504' },
        { code: 'HK', name: 'Hong Kong', countryCode: '+852' },
        { code: 'HU', name: 'Hungary', countryCode: '+36' },
        { code: 'IS', name: 'Iceland', countryCode: '+354' },
        { code: 'IN', name: 'India', countryCode: '+91' },
        { code: 'ID', name: 'Indonesia', countryCode: '+62' },
        { code: 'IR', name: 'Iran, Islamic Republic Of', countryCode: '+98' },
        { code: 'IQ', name: 'Iraq', countryCode: '+964' },
        { code: 'IE', name: 'Ireland', countryCode: '+353' },
        { code: 'IM', name: 'Isle Of Man', countryCode: '+44' },
        { code: 'IL', name: 'Israel', countryCode: '+972' },
        { code: 'IT', name: 'Italy', countryCode: '+39' },
        { code: 'JM', name: 'Jamaica', countryCode: '+1876' },
        { code: 'JP', name: 'Japan', countryCode: '+81' },
        { code: 'JE', name: 'Jersey', countryCode: '+44' },
        { code: 'JO', name: 'Jordan', countryCode: '+962' },
        { code: 'KZ', name: 'Kazakhstan', countryCode: '+7' },
        { code: 'KE', name: 'Kenya', countryCode: '+254' },
        { code: 'KI', name: 'Kiribati', countryCode: '+686' },
        { code: 'KR', name: 'Korea', countryCode: '+82' },
        { code: 'KW', name: 'Kuwait', countryCode: '+965' },
        { code: 'KG', name: 'Kyrgyzstan', countryCode: '+996' },
        { code: 'LA', name: 'Lao People\'s Democratic Republic', countryCode: '+856' },
        { code: 'LV', name: 'Latvia', countryCode: '+371' },
        { code: 'LB', name: 'Lebanon', countryCode: '+961' },
        { code: 'LS', name: 'Lesotho', countryCode: '+266' },
        { code: 'LR', name: 'Liberia', countryCode: '+231' },
        { code: 'LY', name: 'Libyan Arab Jamahiriya', countryCode: '+218' },
        { code: 'LI', name: 'Liechtenstein', countryCode: '+417' },
        { code: 'LT', name: 'Lithuania', countryCode: '+370' },
        { code: 'LU', name: 'Luxembourg', countryCode: '+352' },
        { code: 'MO', name: 'Macao', countryCode: '+853' },
        { code: 'MK', name: 'Macedonia', countryCode: '+389' },
        { code: 'MG', name: 'Madagascar', countryCode: '+261' },
        { code: 'MW', name: 'Malawi', countryCode: '+265' },
        { code: 'MY', name: 'Malaysia', countryCode: '+60' },
        { code: 'MV', name: 'Maldives', countryCode: '+960' },
        { code: 'ML', name: 'Mali', countryCode: '+223' },
        { code: 'MT', name: 'Malta', countryCode: '+356' },
        { code: 'MH', name: 'Marshall Islands', countryCode: '+692' },
        { code: 'MQ', name: 'Martinique', countryCode: '+596' },
        { code: 'MR', name: 'Mauritania', countryCode: '+222' },
        { code: 'MU', name: 'Mauritius', countruCode: '+230' },
        { code: 'YT', name: 'Mayotte', countryCode: '+269' },
        { code: 'MX', name: 'Mexico', countryCode: '+52' },
        { code: 'FM', name: 'Micronesia, Federated States Of', countryCode: '+691' },
        { code: 'MD', name: 'Moldova', countryCode: '+373' },
        { code: 'MC', name: 'Monaco', countryCode: '+377' },
        { code: 'MN', name: 'Mongolia', countryCode: '+976' },
        { code: 'ME', name: 'Montenegro', countryCode: '+382' },
        { code: 'MS', name: 'Montserrat', countryCode: '+1664' },
        { code: 'MA', name: 'Morocco', countryCode: '+212' },
        { code: 'MZ', name: 'Mozambique', countryCode: '+258' },
        { code: 'MM', name: 'Myanmar', countryCode: '+95' },
        { code: 'NA', name: 'Namibia', countryCode: '+264' },
        { code: 'NR', name: 'Nauru', countryCode: '+674' },
        { code: 'NP', name: 'Nepal', countryCode: '+977' },
        { code: 'NL', name: 'Netherlands', countryCode: '+31' },
        { code: 'AN', name: 'Netherlands Antilles', countrycCode: '+92' },
        { code: 'NC', name: 'New Caledonia', countryCode: '+687' },
        { code: 'NZ', name: 'New Zealand', countryCode: '+64' },
        { code: 'NI', name: 'Nicaragua', countryCode: '+505' },
        { code: 'NE', name: 'Niger', countryCode: '+227' },
        { code: 'NG', name: 'Nigeria', countryCode: '+234' },
        { code: 'NU', name: 'Niue', countryCode: '+683' },
        { code: 'NF', name: 'Norfolk Island', countryCode: '+672' },
        { code: 'MP', name: 'Northern Mariana Islands', countryCode: '+670' },
        { code: 'NO', name: 'Norway', countryCode: '+47' },
        { code: 'OM', name: 'Oman', countryCode: '+968' },
        { code: 'PK', name: 'Pakistan', countryCode: '+92' },
        { code: 'PW', name: 'Palau', countryCode: '+680' },
        { code: 'PS', name: 'Palestinian Territory, Occupied', countryCode: '+970' },
        { code: 'PA', name: 'Panama', countryCode: '+507' },
        { code: 'PG', name: 'Papua New Guinea', countryCode: '+675' },
        { code: 'PY', name: 'Paraguay', countryCode: '+595' },
        { code: 'PE', name: 'Peru', countryCode: '+51' },
        { code: 'PH', name: 'Philippines', countryCode: '+63' },
        { code: 'PN', name: 'Pitcairn', countryCode: '+64' },
        { code: 'PL', name: 'Poland', countryCode: '+48' },
        { code: 'PT', name: 'Portugal', countryCode: '+351' },
        { code: 'PR', name: 'Puerto Rico', countryCode: '+1787' },
        { code: 'QA', name: 'Qatar', countryCode: '+974' },
        { code: 'RE', name: 'Reunion', countryCode: '+262' },
        { code: 'RO', name: 'Romania', countryCode: '+40' },
        { code: 'RU', name: 'Russian Federation', countryCode: '+7' },
        { code: 'RW', name: 'Rwanda', countryCode: '+250' },
        { code: 'BL', name: 'Saint Barthelemy', countryCode: '+590' },
        { code: 'SH', name: 'Saint Helena', countryCode: '+290' },
        { code: 'KN', name: 'Saint Kitts And Nevis', countryCode: '+1869' },
        { code: 'LC', name: 'Saint Lucia', countryCode: '+1758' },
        { code: 'MF', name: 'Saint Martin', countryCode: '+590' },
        { code: 'PM', name: 'Saint Pierre And Miquelon', countryCode: '+508' },
        { code: 'VC', name: 'Saint Vincent And Grenadines', countryCode: '+1' },
        { code: 'WS', name: 'Samoa', countryCode: '+685' },
        { code: 'SM', name: 'San Marino', countryCode: '+378' },
        { code: 'ST', name: 'Sao Tome And Principe', countryCode: '+239' },
        { code: 'SA', name: 'Saudi Arabia', countryCode: '+966' },
        { code: 'SN', name: 'Senegal', countryCode: '+221' },
        { code: 'RS', name: 'Serbia', countryCode: '+381' },
        { code: 'SC', name: 'Seychelles', countryCode: '+248' },
        { code: 'SL', name: 'Sierra Leone', countryCode: '+232' },
        { code: 'SG', name: 'Singapore', countryCode: '+65' },
        { code: 'SK', name: 'Slovakia', countryCode: '+421' },
        { code: 'SI', name: 'Slovenia', countryCode: '+386' },
        { code: 'SB', name: 'Solomon Islands', countryCode: '+677' },
        { code: 'SO', name: 'Somalia', countryCode: '+252' },
        { code: 'ZA', name: 'South Africa', countryCode: '+27' },
        { code: 'GS', name: 'South Georgia And Sandwich Isl.', countryCode: '+500' },
        { code: 'ES', name: 'Spain', countryCode: '+34' },
        { code: 'LK', name: 'Sri Lanka', countryCode: '+94' },
        { code: 'SD', name: 'Sudan', countryCode: '+249' },
        { code: 'SR', name: 'Suriname', countryCode: '+597' },
        { code: 'SJ', name: 'Svalbard And Jan Mayen', countryCode: '+47' },
        { code: 'SZ', name: 'Swaziland', countryCode: '+268' },
        { code: 'SE', name: 'Sweden', countryCode: '+46' },
        { code: 'CH', name: 'Switzerland', countryCode: '+41' },
        { code: 'SY', name: 'Syrian Arab Republic', countryCode: '+963' },
        { code: 'TW', name: 'Taiwan', countryCode: '+886' },
        { code: 'TJ', name: 'Tajikistan', countryCode: '+7' },
        { code: 'TZ', name: 'Tanzania', countryCode: '+255' },
        { code: 'TH', name: 'Thailand', countryCode: '+66' },
        { code: 'TL', name: 'Timor-Leste', countryCode: '+670' },
        { code: 'TG', name: 'Togo', countryCode: '+228' },
        { code: 'TK', name: 'Tokelau', countryCode: '+690' },
        { code: 'TO', name: 'Tonga', countryCode: '+676' },
        { code: 'TT', name: 'Trinidad And Tobago', countryCode: '+1868' },
        { code: 'TN', name: 'Tunisia', countryCode: '+216' },
        { code: 'TR', name: 'Turkey', countryCode: '+90' },
        { code: 'TM', name: 'Turkmenistan', countryCode: '+7' },
        { code: 'TC', name: 'Turks And Caicos Islands', countryCode: '+1649' },
        { code: 'TV', name: 'Tuvalu', countryCode: '+688' },
        { code: 'UG', name: 'Uganda', countryCode: '+256' },
        { code: 'UA', name: 'Ukraine', countryCode: '+380' },
        { code: 'AE', name: 'United Arab Emirates', countryCode: '+971' },
        { code: 'GB', name: 'United Kingdom', countryCode: '+44' },
        { code: 'UM', name: 'United States Outlying Islands', countryCode: '+246' },
        { code: 'UY', name: 'Uruguay', countryCode: '+598' },
        { code: 'UZ', name: 'Uzbekistan', countryCode: '+7' },
        { code: 'VU', name: 'Vanuatu', countryCode: '+678' },
        { code: 'VE', name: 'Venezuela', countryCode: '+58' },
        { code: 'VN', name: 'Viet Nam', countryCode: '+84' },
        { code: 'VG', name: 'Virgin Islands, British', countryCode: '+1284' },
        { code: 'VI', name: 'Virgin Islands, U.S.', countryCode: '+1340' },
        { code: 'WF', name: 'Wallis And Futuna', countryCode: '+681' },
        { code: 'EH', name: 'Western Sahara', countryCode: '+212' },
        { code: 'YE', name: 'Yemen', countryCode: '+967' },
        { code: 'ZM', name: 'Zambia', countryCode: '+260' },
        { code: 'ZW', name: 'Zimbabwe', countryCode: '+263' },
        { code: 'MH', name: 'Marshall Islands', countryCode: '+69' },
        { code: 'RU', name: 'Russian Federation', countryCode: '+79', baseCode: '+7' },
    ]

    return countries.filter((country) => {
        if ((country.countryCode === countryCode) || (country && country.baseCode === countryCode)) {
            return country;
        }
    });
}